"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCachedCurrentToken = exports.setCachedCurrentToken = exports.getCachedCurrentToken = void 0;
var currentToken = null;
var getScopeCurrentToken = function () { return currentToken; };
var setScopeCurrentToken = function (newToken) {
    currentToken = newToken;
};
var getCachedCurrentToken = function () {
    return getScopeCurrentToken();
};
exports.getCachedCurrentToken = getCachedCurrentToken;
var setCachedCurrentToken = function (newToken) {
    setScopeCurrentToken(newToken);
};
exports.setCachedCurrentToken = setCachedCurrentToken;
var clearCachedCurrentToken = function () {
    setScopeCurrentToken(null);
};
exports.clearCachedCurrentToken = clearCachedCurrentToken;
